import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { api, errorText } from "../lib/api";
import { Input } from "../components/ui/input";
import { L } from "./ProjectForm";

export const PaymentsTab = () => {
  const [cfg, setCfg] = useState(null);
  const [keyId, setKeyId] = useState("rzp_test_Sx2aOCifblLMsL");
  const [secret, setSecret] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/payments/config").then((r) => { setCfg(r.data); if (r.data?.key_id) setKeyId(r.data.key_id); }).catch(() => setCfg({ configured: false }));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/admin/payments/config", { key_id: keyId, key_secret: secret });
      setCfg(data);
      setSecret("");
      toast.success("Razorpay connected");
    } catch (err) {
      toast.error(errorText(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="border border-line bg-ivory" data-testid="admin-payments">
      <div className="border-b border-line p-5">
        <h2 className="font-serif text-2xl text-wine">Razorpay payments</h2>
        <p className="text-xs text-muted-ink">Connect once, then create payment links from any enquiry.</p>
      </div>
      <div className="space-y-6 p-5">
        {cfg?.configured && (
          <p className="flex items-center gap-2 text-sm text-charcoal" data-testid="payments-status">
            <CheckCircle2 size={16} className="text-wine" /> Connected · {cfg.mode === "live" ? "Live mode" : "Test mode (no real money)"} · {cfg.key_id}
          </p>
        )}
        <div className="grid gap-4 sm:grid-cols-2">
          <div><L>Key ID</L><Input value={keyId} onChange={(e) => setKeyId(e.target.value)} data-testid="payments-key-id" /></div>
          <div><L>Key Secret</L><Input type="password" autoComplete="off" value={secret} onChange={(e) => setSecret(e.target.value)} placeholder={cfg?.configured ? "Saved — enter a new one to replace" : "Paste your Key Secret"} data-testid="payments-key-secret" /></div>
        </div>
        <p className="text-xs leading-relaxed text-muted-ink">Find these in Razorpay Dashboard → Account &amp; Settings → API Keys. The secret is stored securely and never shown again.</p>
      </div>
      <div className="flex justify-end border-t border-line p-5">
        <button onClick={save} disabled={saving || !secret} className="btn btn-primary disabled:opacity-60" data-testid="payments-save">{saving ? "Checking…" : "Connect Razorpay"}</button>
      </div>
    </div>
  );
};
